"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationSaga = translationSaga;
var _effects = require("redux-saga/effects");
var _api = require("../../../utils/api");
var _actions = require("../../../utils/actions");
var _user = require("../../user");
var tTypes = _interopRequireWildcard(require("./types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function getLocalizationsSaga(_ref) {
  let {
    type
  } = _ref;
  return function* () {
    try {
      const token = yield (0, _effects.select)(_user.selectToken);
      const {
        api: apiURL
      } = yield (0, _effects.select)(_user.selectUrls);
      const resp = yield (0, _effects.call)(_api.getAPITranslationsValues, {
        prefUrl: apiURL,
        token
      });
      const parseResp = yield (0, _effects.call)(() => resp.json());
      yield (0, _effects.put)((0, _actions.requestSuccess)(type, parseResp));
    } catch (error) {
      // eslint-disable-next-line no-console
      yield (0, _effects.call)(() => console.log('catch', error, type));
      yield (0, _effects.put)((0, _actions.requestError)(type, {
        message: error.message
      }));
    }
  }();
}
function getLocalizationsUiSaga(_ref2) {
  let {
    type
  } = _ref2;
  return function* () {
    try {
      const token = yield (0, _effects.select)(_user.selectToken);
      const {
        api: apiURL
      } = yield (0, _effects.select)(_user.selectUrls);
      const resp = yield (0, _effects.call)(_api.getAPITranslationsInterface, {
        prefUrl: apiURL,
        token
      });
      const parseResp = yield (0, _effects.call)(() => resp.json());
      yield (0, _effects.put)((0, _actions.requestSuccess)(type, parseResp));
    } catch (error) {
      // eslint-disable-next-line no-console
      yield (0, _effects.call)(() => console.log('catch', error, type));
      yield (0, _effects.put)((0, _actions.requestError)(type, {
        message: error.message
      }));
    }
  }();
}
function* translationSaga() {
  yield (0, _effects.all)([(0, _effects.takeLatest)(tTypes.GET_LOCALIZATIONS, getLocalizationsSaga), (0, _effects.takeLatest)(tTypes.GET_LOCALIZATIONS_UI, getLocalizationsUiSaga)]);
}